import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const maintenanceWorkflowFowardingStatus: Record<string, string> = {
  canceled: 'Declinado',
  completed: 'Finalizado',
  ongoing_checkin: 'Pendente de check-in',
  ongoing_establishment_choice: 'Aguardando resposta do estabelecimento',
  ongoing_directive: 'Aguardando execução',
  ongoing_financial_review: 'Análise financeira',
  ongoing_fiscal_assessment: 'Análise de notas fiscais',
}

export const maintenanceWorkflowFowardingStatusOptions = strategyToOptions(maintenanceWorkflowFowardingStatus)